import React, { useState } from "react";

import Servicesbanner from '../Servicesbanner';
import Servicescontent from '../Servicescontent';
import Testimonials from '../Testimonials';
import Servicesstep from '../Servicesstep';

const Tuitionpaymentsforcanada = () => {

  const [steps, setSteps] = useState([
    { 
      stepNumber: 1,
      stepbadgeText: "Step 1", 
      steptitle: "Submit a Payment Request", 
      steptext: "Begin by clicking “Get a Tuition Payment Quote” and complete a quick form with details like the amount, currency, and institution.",
      stepimageSrc: "../Images/number-1.png"
    },
    { 
      stepNumber: 2,
      stepbadgeText: "Step 2", 
      steptitle: "Receive a Customized Quote", 
      steptext: "Our team will calculate the exchange rate, any applicable fees, and the final amount to be sent. We’ll provide a clear quote for your review.",
      stepimageSrc: "../Images/number-2.png"
    },
    { 
      stepNumber: 3,
      stepbadgeText: "Step 3", 
      steptitle: "Approve and Complete Payment", 
      steptext: "Review the quote and approve it if it meets your needs. Follow our secure payment instructions to complete the transaction.",
      stepimageSrc: "../Images/number-3.png"
    },
    { 
      stepNumber: 4,
      stepbadgeText: "Step 4", 
      steptitle: "Tuition Payment Processing", 
      steptext: "Once payment is received, we process the transfer and send the tuition directly to the Canadian institution. You’ll receive updates along the way",
      stepimageSrc: "../Images/number-4.png"
    },
    { 
      stepNumber: 5,
      stepbadgeText: "Step 5", 
      steptitle: "Confirmation and Receipt", 
      steptext: "Upon completion, you’ll receive a confirmation email, along with a receipt for your records and any proof of payment if required by the institution.",
      stepimageSrc: "../Images/number-5.png"
    }
  ]);

  return (
    <>
      <Servicesbanner 
        title="Tuition Payments for" 
        highlight="Canada" 
        />
      <Servicescontent 
        conttitle="Service Overview" 
        content={<><p>Our tuition payments for canada service simplifies international tuition payments for students studying in canada. Avoid the hassle and high fees of international transfers with our secure, efficient solution. Whether paying from your home country or on behalf of a student, we provide competitive exchange rates, transparent fees, and quick processing to ensure tuition arrives on time. You can rely on us for a smooth, cost-effective way to handle tuition payments to canadian institutions.</p></>}
        buttonlink="#"
        label="Get a Tuition Payment Quote"
      />
      <Servicesstep 
        steps={steps} 
      />
      <Testimonials />
    </>
  );
}

export default Tuitionpaymentsforcanada;
